export default {
  // path: '/new-detail',
  meta: {
    title: '会话记录详情'
  },
};
